// ── Cómo se escribe la plata, en un solo lugar ───────────────────────────────
// El dinero se guarda y se transmite SIEMPRE como centavos enteros. Esta es la
// única función que los convierte en texto para mostrar.
//
// Vivía duplicada en tres lados (2026-08-31): web/lib/money.ts,
// server/services/billingDocumentTemplate.ts y —divergente— los correos de
// cobro, que formateaban con locale 'es' fijo. El resultado era que un cliente
// recibía una factura que decía "$150.00" y un correo por el mismo cobro que
// decía "150,00 US$". Lo destapó el harness de punta a punta, no una revisión:
// dos de las copias eran idénticas y nadie iba a notar que la tercera no.
//
// El locale sale de la MONEDA, no de quien lee: un monto en dólares se escribe
// como se escribe un monto en dólares. Cambiarlo por el idioma del lector haría
// que la misma factura se vea distinta según quién la abra, que es justamente
// lo que un documento de cobro no puede hacer.
const CURRENCY_LOCALE = {
    usd: 'en-US',
    dop: 'es-DO',
};
export function formatMoney(cents, currency) {
    const code = currency.toUpperCase();
    const locale = CURRENCY_LOCALE[currency.toLowerCase()] ?? 'en-US';
    return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(cents / 100);
}
//# sourceMappingURL=money.js.map